import React, { useCallback, ReactElement } from 'react';
import { useNavigate } from 'react-router';
import Card from '../../../../components/card/card.component';
import Button from '../../../../components/button/button.component';
import TextBlock from '../../../../components/text-block/text-block.component';
import { ROUTE_DASHBOARD } from '../../../../constants/system/routes';

const NotFound: ReactMemoComponent = React.memo((): ReactElement => {
  const navigate: ReactRouterNavigate = useNavigate();

  const clickToDashboard: MouseEventHandlerFunction = useCallback((): void => {
    navigate({
      pathname: ROUTE_DASHBOARD,
    });
  }, []);

  return (
    <Card isFlat isContainer withNoBackground>
      <TextBlock>
        Page you requested was not found.
      </TextBlock>
      <Button isText isDefault onClick={clickToDashboard}>
        Go to main
      </Button>
    </Card>
  );
});

export default NotFound;
